import React from 'react';
import { connect } from 'react-redux';

import { setHostory, setQuestion } from '../../reducers/targets.js';

const FeedbackHOC = function (Wrap) {
    class Feedbacks extends React.Component {
        constructor(props) {
            super(props)
            this.state = {
                index: 0
            }
            this.lastHostory = this.lastHostory.bind(this)
            this.handleShow = this.handleShow.bind(this)
            this.goback = this.goback.bind(this)
            this.getItem = this.getItem.bind(this)
        }
        lastHostory() {
            let length = this.props.history.length
            if (length == 0) {
                return false
            } else {
                return this.props.history[length - 1]
            }
        }
        handleShow(item) {
            let history = this.props.history
            let index = history.findIndex((items) => {
                return items.id == item.id
            })
            if (index != -1) {
                history = history.slice(0, index + 1)
            } else {
                history = history.concat(item)
            }
            this.props.setHistory(history)
        }
        goback() {
            let history = this.props.history
            history = history.slice(0, history.length - 1)
            this.props.setHistory(history)
        }
        getItem(id) {
            let lang = localStorage.getItem('language') || this.props.locales.locale
            let questions = this.props.question.list[lang] || this.props.question.list['en']
            return questions.filter((item) => {
                return item.id == id
            })
        }
        render() {
            return <Wrap
                lastHostory={this.lastHostory}
                handleShow={this.handleShow}
                getItem={this.getItem}
                goback={this.goback}
                {...this.props} />
        }
    }

    const mapStateToProps = (state) => ({
        question: state.scratchGui.targets.questions,
        history: state.scratchGui.targets.questionHistory,
        locales: state.locales
    })
    const mapDispatchToProps = (dispatch) => ({
        setHistory: (value) => {
            dispatch(setHostory(value))
        },
        setQuestion: (arg) => {
            dispatch(setQuestion(arg))
        }
    })
    return connect(mapStateToProps, mapDispatchToProps)(Feedbacks)
}

export {
    FeedbackHOC
}